module.exports = __webpack_public_path__ + "img/recovery.426c539f.png";